import React, { useState, useEffect } from 'react'
import Navbar from '../Comman_Layout/Header/Navbar'
import Footer from '../Comman_Layout/Footer/Footer'
import Gotop from "../Comman_Layout/Gotop";
import AboutBanner from './AboutBanner';
import AboutArea from './AboutArea';
import MissionVisionValue from './MissionVisionValue';
import OurHistory from './OurHistory';
import WorkLife from './WorkLife';
import GalleryWrap from './GalleryWrap';
import FeedbackArea from './FeedbackArea';
import OurAwesomeTeam from './OurAwesomeTeam';
import OurPartners from './OurPartners';
import OurAssociateChannelPartners from './OurAssociateChannelPartners';
import AlobhaGroup from './AlobhaGroup';
import { Helmet } from 'react-helmet-async'
import { useSelector, useDispatch } from "react-redux";
import { getAboutusPageMetaData } from '../../Redux/action/Homeaction';

const About = () => {
  const dispatch = useDispatch();
  const [isLoading, setisLoading] = useState(false);
  useEffect(() => {
    setisLoading(false);
    dispatch(getAboutusPageMetaData());
    setisLoading(true);
  }, []);
  const aboutuspagemetadataDetail = useSelector((state) => state.HomeReducer ? state.HomeReducer.aboutuspagemetadataList.data : "");
  // console.log('About us page meta data =', aboutuspagemetadataDetail);
  return (
    <>
      {
        isLoading && <Helmet>
          <title> {aboutuspagemetadataDetail ? `${aboutuspagemetadataDetail.metatag}` : `Alobha Technologies: Your Trusted IT Partner`}</title>
          <meta name="description" content={aboutuspagemetadataDetail ? `${aboutuspagemetadataDetail.metadescription}` : ""} />
          <meta name="keywords" content={aboutuspagemetadataDetail ? `${aboutuspagemetadataDetail.keyword}` : ""} />
        </Helmet>
      }

      <Navbar />
      <AboutBanner />
      <AboutArea />
      <MissionVisionValue />
      <OurHistory />
      <WorkLife />
      <GalleryWrap />
      <FeedbackArea />
      <OurAwesomeTeam />
      <OurPartners />
      <OurAssociateChannelPartners />
      <AlobhaGroup />
      <Footer />
      <Gotop />
    </>
  )
}

export default About